import { Component, Inject } from "@angular/core";
import { BV_DIALOG_DATA, BvDialogRef } from "../../design-system";

import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";

export interface ConfirmDialogData {
  title?: string;
  message: string;
  acceptButton?: string;
  cancelButton?: string;
}

@Component({
    selector: "app-confirm-dialog",
    templateUrl: "./confirm-dialog.component.html",
    styleUrls: ["./confirm-dialog.component.scss"],
    imports: [BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent, BvButtonComponent]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: BvDialogRef<ConfirmDialogComponent>,
    @Inject(BV_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}